module.exports = __webpack_public_path__ + "public/media/ic_ok_blue.cbb576c7.svg";